import React from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';
import { useSessionData, AccessStatus } from '@confluence/session-data';

import { WatchDialogShortcut } from './WatchDialogShortcut';
import { UpdateContentType } from './UpdateType';
import { getWatchDialogQuery } from './getWatchDialogQuery';
import { processWatchData } from './processWatchData';

type WatchSettingsOverflowMenuShortcutProps = {
	openWatchSettingsMenu: () => void;
	contentId: string;
	contentType: string;
};

export const WatchSettingsOverflowMenuShortcut: React.FC<
	WatchSettingsOverflowMenuShortcutProps
> = ({ openWatchSettingsMenu, contentId, contentType }) => {
	const { accessStatus } = useSessionData();
	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = useQuery(getWatchDialogQuery(), {
		variables: {
			contentId,
		},
		skip: !isLicensed,
	});

	const updateQueryHandler = (cache: any, watchTarget: UpdateContentType, newDataValue: any) => {
		const query = getWatchDialogQuery();
		const contentData = cache.readQuery({
			query,
			variables: { contentId },
		});

		// We only update the cache with UpdateContentType.CONTENT if the watch/unwatch mutations are fired via shortcut
		if (watchTarget === UpdateContentType.CONTENT) {
			contentData.singleContent.currentUserIsWatching = newDataValue;
		}

		cache.writeQuery({
			query,
			data: contentData,
		});
	};

	const {
		isCurrentUserWatching: isWatchingContent,
		isWatchingChildren,
		hasAncestorWatchingChildren,
		isWatchingSpace,
	} = processWatchData(data);
	const shortcutParams = {
		isWatchingContent,
		isWatchingChildren,
		hasAncestorWatchingChildren,
		isWatchingSpace,
	};

	if (!isLicensed) {
		return null;
	}

	return (
		<Subscribe to={[FlagsStateContainer]}>
			{(flags: FlagsStateContainer) => (
				<WatchDialogShortcut
					contentId={contentId}
					contentType={contentType}
					flagsContainer={flags}
					openDialog={openWatchSettingsMenu}
					updateQueryHandler={updateQueryHandler}
					params={shortcutParams}
				/>
			)}
		</Subscribe>
	);
};
